import '~/pages/sessions/index';
import initSignInRegisterTracking from './sign_in_register_tracking';

document.addEventListener('DOMContentLoaded', initSignInRegisterTracking);
